const SimNoProxyKey = Symbol.for("simple-boot:sim-no-proxy-metadata");
const SimNoProxy = (target, propertyKey) => {
  if (propertyKey === void 0) {
    Reflect.defineMetadata(SimNoProxyKey, true, target);
    return;
  }
  Reflect.defineMetadata(SimNoProxyKey, true, target, propertyKey);
};
const getSimNoProxy = (target, propertyKey) => {
  try {
    if (propertyKey === void 0) {
      return Reflect.getMetadata(SimNoProxyKey, target);
    }
    return Reflect.getMetadata(SimNoProxyKey, target, propertyKey);
  } catch (e) {
    return void 0;
  }
};
const isSimNoProxy = (target, propertyKey) => {
  if (target === null || target === void 0) {
    return false;
  }
  return getSimNoProxy(target, propertyKey) === true;
};
const simNoProxy = SimNoProxy;
export {
  SimNoProxy,
  SimNoProxyKey,
  getSimNoProxy,
  isSimNoProxy,
  simNoProxy
};
//# sourceMappingURL=SimNoProxy.js.map
